import styled from 'styled-components';

export const StyledPriceContainer = styled.div`
padding: 0.5em;
border-radius: 10px; 
border: 1px solid rgba(34,36,38,.15);
width: 30%;
margin-bottom: 10px;
font-size: 16px !important;
text-align: center;
justify-content: center;
color: rgba(0,0,0,.87);
`
export const StyledPriceWrapper = styled.div`
display: flex;
align-items: baseline;
gap: 10px;
justify-content: center;
`